export const environment = {
  production: false,
  env: 'dev',
  groups: {
    admin: 'XAZ-CERBERUS_ADMIN_DEV',
    user: 'XAZ-CERBERUS_USER_DEV',
    lead: 'XAZ-CERBERUS_LEAD_DEV',
  },
  apiGatewayUrl: 'https://cerberus-dev.api.nprd-astrazeneca.com/',
};
